import { render, staticRenderFns } from "./partyBook.vue?vue&type=template&id=12deddc4&scoped=true&"
import script from "./partyBook.vue?vue&type=script&lang=js&"
export * from "./partyBook.vue?vue&type=script&lang=js&"
import style0 from "./partyBook.vue?vue&type=style&index=0&id=12deddc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12deddc4",
  null
  
)

export default component.exports